import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  constructor(
    private translate: TranslateService,
    private router: Router,
  ) {}

  setLanguage(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('app_lang', lang);
    // this.router.navigate([], {
    //   queryParams: { lang },
    //   queryParamsHandling: 'merge',
    // });
  }
  setLang(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('app_lang', lang);
  }
    
  
}
